import { render, staticRenderFns } from "./TenantEditCatalog.vue?vue&type=template&id=e2e0ad7c&scoped=true&"
import script from "./TenantEditCatalog.vue?vue&type=script&lang=js&"
export * from "./TenantEditCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e0ad7c",
  null
  
)

export default component.exports